import { Component, Input, OnInit } from '@angular/core';
import { IconDefinition } from '@fortawesome/pro-duotone-svg-icons';
import { Store } from '@ngxs/store';
import { WellKnownIconsEnum } from 'src/app/helper/iconHelper';
import { UpdateCallTag } from '../../../../../store/samwin/call-tags/call-tags.actions';

@Component({
   selector: 'samweb-call-memo-cell',
   templateUrl: './call-memo-cell.component.html',
   styleUrls: ['./call-memo-cell.component.scss'],
})
export class CallMemoCellComponent implements OnInit {
   @Input()
   public callId: number;

   @Input()
   public messageId: string = null;

   @Input()
   public memo: string;

   public clearFilterIcon: IconDefinition = WellKnownIconsEnum.CLEAR.iconSmall;
   public isMouseOverComponent = false;

   constructor(private store: Store) {}

   ngOnInit(): void {}

   memoUpdated(changedValue: string): void {
      this.store.dispatch(new UpdateCallTag(this.callId, 'MEMO', changedValue, this.messageId));
   }
}
